import { ConfigurationArchelDto } from '../api/generated';

export const WHOLE_MODEL_DISPLAY_NAME = 'Whole model';

export const getDisplayFilterValue = (value?: string | null) => {
  const displayValue = value?.trim();

  if (!displayValue || displayValue.toLowerCase() === 'undefined') {
    return undefined;
  }

  return displayValue;
};

export const isDisplayFilterValue = (
  value: string | undefined,
): value is string => value !== undefined;

export const getDisplayFilterValues = (values: string[]) =>
  values.map(getDisplayFilterValue).filter(isDisplayFilterValue);

export const getArchelDisplayName = (archel: ConfigurationArchelDto) =>
  getDisplayFilterValue(
    archel.analogueModelComputeSettingArchelMap?.identifier,
  ) ?? getDisplayFilterValue(archel.name);

export type ModelAreaDisplayOption = {
  modelAreaId?: string | null;
  modelAreaType?: string | null;
  name?: string | null;
};

export const getModelAreaDisplayName = (
  modelArea?: ModelAreaDisplayOption | null,
) =>
  getDisplayFilterValue(modelArea?.modelAreaType) ??
  getDisplayFilterValue(modelArea?.name) ??
  WHOLE_MODEL_DISPLAY_NAME;
